/**
 * This is a polyfill for the Node.js Buffer object in browser environments
 * It's used to handle Base64 encoding/decoding without requiring the Buffer object
 */

// Base64 encoding function for browser environments
export const btoa = (str) => {
  if (typeof window !== 'undefined' && window.btoa) {
    return window.btoa(str);
  }
  
  // Implementation of btoa for environments without native support
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
  let output = '';
  
  for (let i = 0; i < str.length; i += 3) {
    const a = str.charCodeAt(i);
    const b = i + 1 < str.length ? str.charCodeAt(i + 1) : 0;
    const c = i + 2 < str.length ? str.charCodeAt(i + 2) : 0;
    
    const enc1 = a >> 2;
    const enc2 = ((a & 3) << 4) | (b >> 4);
    const enc3 = ((b & 15) << 2) | (c >> 6);
    const enc4 = c & 63;
    
    output += chars.charAt(enc1) + chars.charAt(enc2) + 
              (i + 1 < str.length ? chars.charAt(enc3) : '=') + 
              (i + 2 < str.length ? chars.charAt(enc4) : '=');
  }
  
  return output;
};

// Base64 decoding function for browser environments
export const atob = (base64) => {
  if (!base64) return null;
  
  if (typeof window !== 'undefined' && window.atob) {
    return window.atob(base64);
  }
  
  // Implementation of atob for environments without native support
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
  let output = '';
  
  base64 = base64.replace(/=+$/, '');
  
  for (let i = 0; i < base64.length; i += 4) {
    const enc1 = chars.indexOf(base64.charAt(i));
    const enc2 = chars.indexOf(base64.charAt(i + 1));
    const enc3 = chars.indexOf(base64.charAt(i + 2));
    const enc4 = chars.indexOf(base64.charAt(i + 3));
    
    const a = (enc1 << 2) | (enc2 >> 4);
    const b = ((enc2 & 15) << 4) | (enc3 >> 2);
    const c = ((enc3 & 3) << 6) | enc4;
    
    output += String.fromCharCode(a);
    if (enc3 !== 64) output += String.fromCharCode(b);
    if (enc4 !== 64) output += String.fromCharCode(c);
  }
  
  return output;
};

// Function to simulate Buffer.from(str, 'base64').toString()
export const bufferFromBase64ToString = (base64) => {
  return atob(base64);
};

// Function to simulate Buffer.from(str).toString('base64')
export const bufferFromStringToBase64 = (str) => {
  return btoa(str);
};

// Global Buffer polyfill
if (typeof window !== 'undefined' && typeof Buffer === 'undefined') {
  window.Buffer = {
    from: (data, encoding) => {
      if (encoding === 'base64') {
        return {
          toString: () => atob(data)
        };
      } else {
        return {
          toString: (targetEncoding) => {
            if (targetEncoding === 'base64') {
              return btoa(data);
            }
            return data;
          }
        };
      }
    }
  };
}